<script lang="ts">
  import ClipboardJS from 'clipboard';
  import { createEventDispatcher } from 'svelte';

  import Button from '@/comps-sdk/components/button';
  import { toast as Toast } from '@/comps-sdk/components/toast';
  import { getArrayData } from '@/comps-sdk/utils/array';

  export let receiveResult: any = {};

  $: showResult = receiveResult?.showResult;
  $: successMode = receiveResult?.code === 0;
  $: errorMsg = receiveResult?.msg ?? '领取失败了，请稍后再试～';
  $: cdkeyCode = getArrayData(receiveResult?.showResult?.customData.cdkeyCode).filter(item => item);
  $: cdkeyLink = receiveResult?.showResult?.customData.cdkeyLink || '';

  const dispatch = createEventDispatcher();
  const handleBtnClick = () => {
    if (cdkeyCode && cdkeyLink) {
      location.href = cdkeyLink;
      return;
    }
    dispatch('close');
  };

  const copyCode = (code: string) => {
    ClipboardJS.copy(code);
    Toast('复制成功');
  };
</script>

<div class="result-panel">
  <div class="result-header">
    {showResult?.title}
  </div>
  <div class="result-content">
    {#if cdkeyCode.length}
      {#each cdkeyCode as code, index (index.toString())}
        <div class="cdkey-code-wrapper">
          <div class="cdkey-code" id="cdkey-code">
            {code}
          </div>
          <Button class="btn-copy" mode="small" on:click={() => copyCode(code)}>复制</Button>
        </div>
      {/each}
    {:else}
      <div class="result-desc">
        {successMode ? showResult?.desc : errorMsg}
      </div>
    {/if}
    {#if showResult.img}
      <div class="result-img-wrapper">
        <img class="result-img" src={showResult?.img} alt="" />
      </div>
    {/if}
  </div>
  <div class="btn-wrapper">
    <Button on:click={handleBtnClick}>
      {showResult?.btnText || '我知道了'}
    </Button>
  </div>
</div>

<style lang="scss">
  .result-panel {
    padding: 0 15px;
    min-height: 30vh;
    display: flex;
    flex-direction: column;
    .result-header {
      margin-top: 15px;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #191919;
    }
    .result-content {
      flex: 1;
      margin: 12px 0;
      .cdkey-code-wrapper {
        margin-bottom: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .cdkey-code {
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #191919;
        }
        :global(.btn-copy) {
          width: auto;
          margin-left: 6px;
        }
        :last-child {
          margin-bottom: 0;
        }
      }
      .result-desc {
        text-align: center;
        padding: 0 15px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #191919;
      }
      .result-img-wrapper {
        margin-top: 24px;
        text-align: center;
        .result-img {
          width: auto;
          max-width: 100%;
          max-height: 140px;
          border-radius: 6px;
        }
      }
    }
    .btn-wrapper {
      margin: 10px 0;
      text-align: center;
    }
  }
</style>
